import React from 'react';
import { emptyHandler } from "../../../lib/utils";
export var TabsContextDefaultValue = {
  vertical: false,
  activeTab: '',
  size: 'large',
  getTab: emptyHandler,
  addTab: emptyHandler,
  notifyUpdate: emptyHandler,
  removeTab: emptyHandler,
  shiftFocus: emptyHandler,
  switchTab: emptyHandler
};
export var TabsContext = /*#__PURE__*/React.createContext(TabsContextDefaultValue);
TabsContext.displayName = 'TabsContext';